export default __webpack_public_path__ + "static/media/8.55f59c94.jpg";